
import { Options, Vue } from "vue-class-component";
import Header from "@/components/Header.vue";
import LoginForm from "@/components/LoginForm.vue";
import StorageService from "@/services/StorageService";
import { router } from "@/router";
import { useRoute } from "vue-router";
import { store } from "@/store";
import i18n from "@/i18n";

@Options({
  components: {
    Header,
    LoginForm
  }
})
export default class Login extends Vue {
  private storageService = new StorageService();
  $keycloak: any; //globally defined in main.ts

  async created() {
    const query = useRoute().query;

    if (await this.$keycloak.isAuthenticated()) {
      // Since the user is authenticated we redirect to the home page
      router.replace({ name: "Home" });
    }

    // Handle error messages passed in the query
    if (query.error_title && query.error_detail) {
      store.commit("open", {
        type: "danger",
        title: i18n.global.t(query.error_title as string),
        text: i18n.global.t(query.error_detail as string)
      });
    }
  }
}
